import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import { CommonButton } from '@/components/common'
import { UserMenu } from '@/components/layout'
import { LogoImg } from './styled'
import { TENANT_TOPBAR_CONFIGS } from '@/constants'
import { useTenantContext } from '@/context/TenantContext'
import { useDonorContext } from '@/context/DonorContext'

export const Header = () => {
  const { donor } = useDonorContext()
  const { tenant } = useTenantContext()

  const tenantLogo = useMemo(() => {
    return TENANT_TOPBAR_CONFIGS[tenant?.portal_theme]?.logo
  }, [tenant])

  const onBack = () => {
    window.history.back()
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: '5px 15px',
      }}
    >
      <a href={tenantLogo?.href} aria-label='Home'>
        <LogoImg
          src={tenantLogo?.src}
          alt={tenantLogo?.alt}
          sx={{
            maxWidth: { xs: '130px', md: tenantLogo?.maxWidth },
          }}
        />
      </a>

      <Box
        sx={{
          marginLeft: 'auto',
          display: 'inline-flex',
          gap: { xs: 1, md: 2 },
          alignItems: 'center',
        }}
      >
        <UserMenu id='header-user-menu' donor={donor} showMenu={true} />
        <CommonButton
          id='header-go-back'
          label='Go Back'
          color='primary'
          variant='primary'
          onClick={onBack}
        />
      </Box>
    </Box>
  )
}
